//首页分类查询
import request from '@/utils/request.js'
import Vue from 'vue'

//查询物料分类
export function categoryRootList (query) {
  return request({
    url: Vue.prototype.PROFILE + 'goods/categoryRootList',
    method: 'get',
    params: query,
  })
}

//查询物料类型
export function getCategoryList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/category/detail?id=0',
    method: 'get',
    params: query,
  })
}

//获取广告
export function getAdList () {
  return request({
    url: Vue.prototype.PROFILE + '/basic/adList',
    method: 'get',
    platform: 'H5'
  })
}

//公告列表
export function articleList () {
  return request({
    url: Vue.prototype.PROFILE + '/basic/articleList',
    method: 'get',
  })
}

//公告详情
export function articleInfo (query) {
  return request({
    url: Vue.prototype.PROFILE + '/basic/articleInfo',
    method: 'get',
    params: query
  })
}

//物料列表
export function goodsList (query) {
  return request({
    url: Vue.prototype.PROFILE + '/goods/goodsPageList',
    method: 'get',
    params: query
  })
}
//物料列表
export function goodsList1 (query) {
  return request({
    url: Vue.prototype.PROFILE + '/goods/goodsPageList',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js